import initialState from '../../reducers/initialState';
import * as types from 'actions/actionTypes';

export default function (state = initialState.reducerItemListCampFollowUserTypes, action) {
    switch (action.type) {
        case types.ITEM_LIST_FOLLOW_UP_USER_TYPES_FULFILLED:
            return {
                ItemListCampFollowUserTypes: action.payload ? action.payload.data.results : [{}],
            }
        default:
            return state;
    }
}
